export function PublicValidators (pConfig)
{
  BEditor.formattingStyleRules =
  [
    'direction',
    'letterSpacing',
    'textAlign',
    'textDecoration',
    'textShadow',
    'textTransform',
    'unicodeBidi',
    'whiteSpace',
    'wordSpacing',
    'writingMode',
    'background',
    'backgroundAttachment',
    'backgroundClip',
    'backgroundColor',
    'backgroundImage',
    'backgroundOrigin',
    'backgroundPosition',
    'backgroundPositionX',
    'backgroundPositionY',
    'backgroundRepeat',
    'backgroundSize',
    'color',
    'font',
    'fontFamily',
    'fontSize',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight'
  ];


  if (!window.EditorValidateHTMLConfig)
  {
    window.EditorValidateHTMLConfig = {};
  }

  var pThis = window.EditorValidateHTMLConfig;

  pThis.validAttributes =
  {
    'id': function(s)
    {
      return ((new RegExp('^[A-Za-z0-9_$-]+$')).test(s) ? s : null);
    },

    'class': function(s)
    {
      return ((new RegExp('(?:.|\\s)')).test(s) ? s : null);
    },

    'style': function(s)
    {
      s = s.replace( /\\/g , '/');
      s = s.replace( /\/\*[\S\s]*?\*\//g , '');
      s = s.replace( /(?:&\s*#|(?:j\s*a\s*v\s*a\s*|v\s*b\s*|l\s*i\s*v\s*e\s*)s\s*c\s*r\s*i\s*p\s*t|e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n|-\s*m\s*o\s*z|b\s*e\s*h\s*a\s*v\s*i\s*o\s*r\s*\:[\S\s]*?(?:;|$))/ig , '');
      s = s.replace( /url\s*\(([\S\s]*?)\)/ig , function(bigStr, urlStr)
      {
        return (((new RegExp('^(?:https?\:\/\/|\/\/|\/?default.aspx|\/?resource\/)', 'i')).test(urlStr)) ? urlStr : '');
      });

      return ((new RegExp('(?:.|\\s)')).test(s) ? s : null);
    },

    'src': function(s)
    {
      s = s.replace( /\\/g , '/');
      return ((new RegExp('^(?:https?\:\/\/|\/\/|\/?default.aspx|\/?content\/|\/?resource\/)', 'i')).test(s) ? s : null);
    },

    'name': function(s) {
      s = s.replace( /[^A-Za-z0-9_$.:-]/g , '');
      return ((new RegExp('(?:.|\\s)')).test(s) ? s : null);
    },

    'href': function(s) {
      s = s.replace( /\\/g , '/');
      return ((new RegExp('^(?:(?:ht|f)tp(?:s)?\:\/\/|mailto\:|\/{1,2}|\/?content\/|\/?resource\/|\#)', 'i')).test(s) ? s : null);
    },

    'anchorhref': function(s) {
      s = s.replace( /\\/g , '/');
      return ((new RegExp('^\#', 'i')).test(s) ? s : null);
    },

    'target': function(s) {
      return ((new RegExp('^(?:_blank|_parent|_self|_top)$', 'i')).test(s) ? s : null);
    },

    'title': function(s) {
      return ((new RegExp('(?:.|\\s)')).test(s) ? s : null);
    },

    'color': function(s) {
      return ((new RegExp('^[A-Za-z0-9#\\s]+$')).test(s) ? s : null);
    },

    'face': function(s) {
      return ((new RegExp('^[A-Za-z0-9#\\s]+$')).test(s) ? s : null);
    },

    'size': function(s) {
      return ((new RegExp('^[0-9\\s]+$')).test(s) ? s : null);
    },

    'width': function(s) {
      return ((new RegExp('^[0-9]+%?\\s*$')).test(s) ? s : null);
    },

    'height': function(s) {
      return ((new RegExp('^[0-9]+%?\\s*$')).test(s) ? s : null);
    },

    'listtype': function(s) {
      return ((new RegExp('^(?:disk|circle|square|a|i|1)$', 'i')).test(s) ? s : null);
    },

    'align': function(s) {
      return ((new RegExp('^(?:left|center|right|bottom|top|middle|justify)$', 'i')).test(s) ? s : null);
    },

    'noshade': function(s) {
      return ((new RegExp('^(?:noshade|true|false|1|0|yes|no)$', 'i')).test(s) ? s : null);
    },

    'rules': function(s) {
      return ((new RegExp('^(?:all|cols|groups|none|rows)$', 'i')).test(s) ? s : null);
    },

    'summary': function(s) {
      return ((new RegExp('(?:.|\\s)')).test(s) ? s : null);
    },

    'clear': function(s) {
      return ((new RegExp('^(?:all|both|left|right)$', 'i')).test(s) ? s : null);
    }
  };


  pThis.validTags =
  {
    'A':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'name': pThis.validAttributes['name'],
        'href': pThis.validAttributes['href'],
        'anchorhref': pThis.validAttributes['anchorhref'],
        'target': pThis.validAttributes['target'],
        'title': pThis.validAttributes['title']
      },
    'ABBR':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'ACRONYM':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'ADDRESS':
      {
        'id': pThis.validAttributes['id'],
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'B':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'title': pThis.validAttributes['title']
      },
    'BIG':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'title': pThis.validAttributes['title']
      },
    'BLOCKQUOTE':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'BR':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'clear': pThis.validAttributes['clear']
      },
    'CENTER':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'CITE':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'title': pThis.validAttributes['title']
      },
    'CODE':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'title': pThis.validAttributes['title']
      },
    'DD':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'DFN':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'title': pThis.validAttributes['title']
      },
    'DIV':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align']
      },
    'DL':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'title': pThis.validAttributes['title']
      },
    'DT':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'EM':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'FONT':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'color': pThis.validAttributes['color'],
        'face': pThis.validAttributes['face'],
        'size': pThis.validAttributes['size']
      },
    'H1':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'title': pThis.validAttributes['title']
      },
    'H2':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'title': pThis.validAttributes['title']
      },
    'H3':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'title': pThis.validAttributes['title']
      },
    'H4':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'title': pThis.validAttributes['title']
      },
    'H5':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'title': pThis.validAttributes['title']
      },
    'H6':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'title': pThis.validAttributes['title']
      },
    'HR':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'size': pThis.validAttributes['size'],
        'width': pThis.validAttributes['width'],
        'noshade': pThis.validAttributes['noshade'],
        'color': pThis.validAttributes['color']
      },
    'I':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'IMG':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'src': pThis.validAttributes['src'],
        'align': pThis.validAttributes['align'],
        'alt': pThis.validAttributes['title'],
        'border': pThis.validAttributes['size'],
        'hspace': pThis.validAttributes['size'],
        'vspace': pThis.validAttributes['size'],
        'width': pThis.validAttributes['width'],
        'height': pThis.validAttributes['height']
      },
    'KBD':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'LI':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'NOBR':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'OL':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'type': pThis.validAttributes['listtype'],
        'start': pThis.validAttributes['size'],
        'title': pThis.validAttributes['title']
      },
    'P':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'title': pThis.validAttributes['title']
      },
    'PRE':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'S':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'SAMP':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'SMALL':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'title': pThis.validAttributes['title']
      },
    'SPAN':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'STRONG':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'STRIKE':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'SUB':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'SUP':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'TABLE':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'background': pThis.validAttributes['src'],
        'bgcolor': pThis.validAttributes['color'],
        'border': pThis.validAttributes['size'],
        'bordercolor': pThis.validAttributes['color'],
        'cellspacing': pThis.validAttributes['size'],
        'cellpadding': pThis.validAttributes['size'],
        'rules': pThis.validAttributes['rules'],
        'summary': pThis.validAttributes['summary'],
        'title': pThis.validAttributes['title'],
        'width': pThis.validAttributes['width'],
        'height': pThis.validAttributes['height']
      },
    'TD':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'valign': pThis.validAttributes['align'],
        'bgcolor': pThis.validAttributes['color'],
        'bordercolor': pThis.validAttributes['color'],
        'colspan': pThis.validAttributes['size'],
        'rowspan': pThis.validAttributes['size'],
        'title': pThis.validAttributes['title']
      },
    'TH':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'valign': pThis.validAttributes['align'],
        'bgcolor': pThis.validAttributes['color'],
        'bordercolor': pThis.validAttributes['color'],
        'colspan': pThis.validAttributes['size'],
        'rowspan': pThis.validAttributes['size'],
        'title': pThis.validAttributes['title']
      },
    'TR':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'align': pThis.validAttributes['align'],
        'valign': pThis.validAttributes['align']
      },
    'TT':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'U':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      },
    'UL':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style'],
        'type': pThis.validAttributes['listtype']
      },
    'VAR':
      {
        'class': pThis.validAttributes['class'],
        'style': pThis.validAttributes['style']
      }
  };

  pThis.invalidTags =
  {
    'SCRIPT': true,
    'OBJECT': true,
    'EMBED': true,
    'FRAMESET': true,
    'FRAME': true,
    'IFRAME': true
  };
}